import { render, staticRenderFns } from "./BusinessPage.vue?vue&type=template&id=8a6472f6&scoped=true"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6472f6",
  null
  
)

export default component.exports